export default "/profile/@username";
